export function salt(n) {
    return Math.random()
        .toString(32)
        .substring(2, n + 2);
}
export function getModifierPropWithValue(entry) {
    const [iconPropKey] = entry;
    const match = /[A-Z]\S+/.exec(iconPropKey);
    if (match === null) {
        return {
            key: null,
            val: null,
        };
    }
    const prop = `${iconPropKey.slice(match.index, match.index + 1).toLowerCase()}${iconPropKey.slice(match.index + 1)}`;
    const propVal = `${iconPropKey.slice(0, match.index)}`;
    return { key: prop, val: propVal };
}
